<div class="wrapper">
  <div class="table-title-bar" #titleDiv>{{ title }}</div>
  <ag-grid-angular
    *ngIf="rowData && rowData.length > 0"
    class="ag-theme-balham"
    [rowData]="rowData"
    [headerHeight]="40"
    [rowHeight]="40"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs"
    (gridReady)="onGridReady($event)"
    (gridSizeChanged)="onGridSizeChanged($event)"
    [gridOptions]="gridOptions"
    [animateRows]="true"
    [pagination]="isPaginationEnabled"
    [modules]="modules"
    [theme]="'legacy'"
  >
  </ag-grid-angular>
  <div class="empty-state-container" *ngIf="!rowData || rowData.length === 0">
    <img class="empty-state-image" src="{{ 'EmptyState.svg' | xsImage }}" />
    <div class="empty-state-caption-top">{{ 'No_Data_Keyword' | saI18n }}</div>
  </div>
</div>
